import React from 'react';


const BtnCellRenderer = ({ clicked, value, colDef }) => {
    return (
        <button className='ag-select-button'>조회</button>
    );
};

export { BtnCellRenderer };